<template src="./SolicitudReclamoForm.html"/>
<style lang="scss" src="./SolicitudReclamoForm.scss"></style>

<script>
import {DatePicker, Divider, Form, FormItem, Input, Option, Select, Upload} from 'element-ui'
import {mapState} from "vuex"
import ScreenSizeMixin from "src/mixins/ScreenSizeMixin";
import {NotifyMixin} from "src/mixins/NotifyMixin";
import {RouterMixin} from "@/mixins/routerMixin";
import {FileMixUploadMixin} from "@/mixins/FileMixUpload";
import {requestReclamosMixin} from "src/api/reclamosApi"

export default {
  name: "SolicitudReclamoForm",
  mixins: [
    requestReclamosMixin,
    ScreenSizeMixin,
    NotifyMixin,
    RouterMixin,
    FileMixUploadMixin,
  ],
  components: {
    [DatePicker.name]: DatePicker,
    [Option.name]: Option,
    [Select.name]: Select,
    [Input.name]: Input,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Upload.name]: Upload,
    [Divider.name]: Divider,
  },
  computed: {
    ...mapState({
      user: state => state.user,
    }),
    getDisabled() {
      return this.formEnabled
    },
    getDisabledAndEditabled() {
      if (this.isEditabled) {
        return false
      }
      return !this.formEnabled
    }
  },
  data() {
    var validateConfirmacionEmail = (rule, value, callback) => {
      this.$log.debug('validateConfirmacionEmail')
      if (value === '') {
        callback(new Error('El correo electrónico es obligatorio'));
      } else if (value !== this.model.email) {
        callback(new Error('El correo electrónico no coincide'));
      } else {
        callback();
      }
    };
    return {
      loading: true,
      errored: false,
      loadingRegiones: true,
      loadingComunas: true,
      mensaje: '',
      model: {
        rut: '',
        nombre: '',
        region: '',
        comuna: '',
        calle: '',
        telefono: '',
        email: '',
        confirmacionEmail: '',
        listaRegiones: [],
        listaComunas: [],
        documentos: []
      },
      rules: {
        rut: [
          {
            length: 10,
            message: 'El RUT es obligatorio',
            trigger: 'blur'
          }
        ],
        nombre: [
          {
            min: 3,
            message: 'El nombre es obligatorio',
            trigger: 'blur'
          }
        ],
        region: [
          {
            required: true,
            message: 'Debe seleccionar la región la cual es obligatorio',
            trigger: 'blur'
          }
        ],
        comuna: [
          {
            required: true,
            message: 'Debe seleccionar la comuna la cual es obligatorio',
            trigger: 'blur'
          }
        ],
        calle: [
          {
            required: true,
            min: 3,
            message: 'La calle es obligatoria',
            trigger: 'blur'
          }
        ],
        telefono: [
          {
            required: true,
            min: 3,
            message: 'El teléfono es obligatorio',
            trigger: 'blur'
          }
        ],
        email: [
          {
            required: true,
            message: 'El correo electrónico es obligatorio',
            trigger: 'blur'
          },
          {
            type: 'email',
            message: 'Ingrese un correo electrónico válido',
            trigger: ['blur', 'change']

          }
        ],
        confirmacionEmail: [
          {
            required: true,
            message: 'El correo electrónico es obligatorio',
            trigger: 'blur'
          },
          {
            type: 'email',
            message: 'Ingrese un correo electrónico válido',
            trigger: ['blur', 'change']

          },
          {
            validator: validateConfirmacionEmail,
            trigger: 'blur'
          }
        ]
      },
    }
  },
  beforeMount() {
    this.model.rut = this.user.current.rut
    this.model.nombre = this.user.current.nombreCompleto
    this.model.email = this.user.current.email
    this.model.confirmacionEmail = this.user.current.email
    this.listaRegiones();
  },
  methods: {
    goBack() {
      this.$emit('on-back')
    },
    listaRegiones() {
      this.loadingRegiones = true
      const datosTerri = {
        cod_pais: 'CL',
      }
      this.getTerritorio(datosTerri)
        .then((res) => {
          if (res.data.statusCode === 200) {
            this.model.listaRegiones = JSON.parse(res.data.datos)
          } else {
            this.showError(`No hay región para el código de país.`)
          }
        })
        .catch(err => {
          this.showError('Ocurrió un error inesperado al cargar las regiones')
          this.$log.debug('err', err)
        })
        .finally(() => {
          this.loadingRegiones = false
        })
    },
    listaComunas() {
      this.loadingComunas = true
      this.model.comuna = ''
      const datosComu = {
        cod_pais: 'CL',
        cod_region: this.model.region
      }
      this.$log.debug('datosComu', datosComu)
      this.getTerritorio(datosComu)
        .then((res) => {
          if (res.data.statusCode === 200) {
            this.model.listaComunas = JSON.parse(res.data.datos)
          } else {
            this.showError(`No hay comuna para el código de país y región.`)
          }
        })
        .catch(err => {
          this.showError('Ocurrió un error inesperado al cargar las comunas')
          this.$log.debug('err', err)
        })
        .finally(() => {
          this.loadingComunas = false
        })
    },
    validate() {
      this.$refs.reclamoForm
        .validate((valid) => {
          if (valid) {
            this.$emit('on-next-step', this.generarData())
          } else {
            this.$log.debug('error submit!!')
          }
        })
    },
    generarData() {
      let data = {}

      data.materno = this.user.current.materno
      data.nombres = this.user.current.nombres
      data.paterno = this.user.current.paterno
      data.calle = this.model.calle
      data.email = this.model.email
      data.telefono = this.model.telefono

      data.region = this.model.listaRegiones.find(x => x.cod_region === this.model.region)
      data.comuna = this.model.listaComunas.find(x => x.cod_comuna === this.model.comuna)

      data.documentos = this.model.documentos
        .map(x => ({name: x.name, content: x.content, type: x.type}))
      return data
    },
    fichaHandleChange(file, fileList) {
      this.handleChange(file, fileList)
      this.$refs.reclamoForm.clearValidate('documentos')
    }
  }

}
</script>
